import * as React from 'react'
import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'
import { APPBAR_HEIGHT } from '../header/AppBar'
import { APPBAR_HEIGHT as APPBAR_HEIGHT_FOR_MOBILE } from '../header/AppBarForMobile'

type Props = {
  children: React.ReactNode
  className?: string
  isUnappliedSticky?: boolean
  'data-test-id'?: string
  onClick?: () => void
}

export const Navbar: React.FC<Props> = (props) => {
  return (
    <div
      data-test-id={props['data-test-id']}
      css={css`
        height: 56px;
        margin: 0 auto;
        ${!props.isUnappliedSticky && `position: sticky;`}
        background-color: ${colors.white00};
        z-index: 19;
        border-top: 1px solid ${colors.borderLight};
        border-bottom: 1px solid ${colors.borderLight};
        ${!props.isUnappliedSticky &&
        `${mq.untilMedium} {
          top: calc(${APPBAR_HEIGHT_FOR_MOBILE} - 1px);
        }
        ${mq.large} {
          top: calc(${APPBAR_HEIGHT} - 1px);
        }`}
      `}
      className={props.className}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  )
}
